import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCircle,
  SkeletonCard,
} from '@/components/common/skeleton';

const CONVERSATION_COUNT = 6;

export const ConversationListSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {Array.from({ length: CONVERSATION_COUNT }).map((_, i) => (
      <SkeletonCard key={i} padding={12} style={styles.cardSpacing}>
        <View style={styles.row}>
          <SkeletonCircle size={40} />
          <View style={styles.textColumn}>
            <SkeletonBone width="70%" height={16} />
            <SkeletonBone width="90%" height={13} />
            <SkeletonBone width="50%" height={12} />
          </View>
          <View style={styles.rightColumn}>
            <SkeletonBone width={40} height={11} />
          </View>
        </View>
      </SkeletonCard>
    ))}
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingTop: 8,
  },
  cardSpacing: {
    marginBottom: 8,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 12,
  },
  textColumn: {
    flex: 1,
    gap: 6,
  },
  rightColumn: {
    alignItems: 'flex-end',
  },
});
